import {
  REVIEW_COPY,
  REVIEWS_EXPLANATION,
  reviewSummaryLine,
  reviewSummaryOf,
  type ProfileReviews as Reviews,
  type Timezone,
} from "@fusiqo/vozqi-shared";
import { useState } from "react";

import { ReviewBody } from "../ui/review-body";
import { ReviewReportDialog } from "./review-report-dialog";
import { useMoreReviews } from "./use-more-reviews";

/**
 * «RESEÑAS» (spec 2026-10-21 §8.1): the verified reviews, newest first, with
 * the average from three and, under it, «¿Qué significa?», as the signals say
 * where their lines come from. Nothing without reviews: no empty blocks. Under
 * each review, its own «Denunciar» (Enmienda 4), with one dialog at a time.
 */
export function ProfileReviews({
  slug,
  reviews,
  businessName,
  timezone,
}: {
  slug: string;
  reviews: Reviews;
  businessName: string;
  timezone: Timezone;
}) {
  const more = useMoreReviews(slug, reviews.next);
  const [reporting, setReporting] = useState<string | null>(null);
  if (reviews.count === 0) return null;
  const summary = reviewSummaryLine(reviewSummaryOf(reviews.count, reviews.sumStars));
  return (
    <section className="profile-section" aria-labelledby="profile-reviews">
      <h2 id="profile-reviews" className="profile-section-title">
        {REVIEW_COPY.profileBlockTitle}
      </h2>
      {summary === null ? null : <p className="profile-reviews-summary">{summary}</p>}
      {/* Of every review, so with the block's head; under each review sits only its own «Denunciar». */}
      <details className="profile-why">
        <summary>{REVIEW_COPY.whatItMeans}</summary>
        <p>{REVIEWS_EXPLANATION}</p>
      </details>
      <ul className="profile-reviews">
        {[...reviews.latest, ...more.reviews].map((review) => (
          <li key={review.id}>
            <ReviewBody review={review} businessName={businessName} timezone={timezone} />
            <button type="button" className="profile-report" onClick={() => setReporting(review.id)}>
              {REVIEW_COPY.report}
            </button>
          </li>
        ))}
      </ul>
      {more.failed ? <p className="shop-empty">No pudimos cargar esto.</p> : null}
      {more.more ? (
        <button type="button" className="profile-more" onClick={more.loadMore}>
          {REVIEW_COPY.seeMore}
        </button>
      ) : null}
      {reporting === null ? null : <ReviewReportDialog slug={slug} reviewId={reporting} onClose={() => setReporting(null)} />}
    </section>
  );
}
